
import { useCases } from "@/core";
import { EDocumentType } from "@/domain/enums";
import { DOCTYPE_NAMES } from "@/presentation/constants";
import { formatDate } from "@/presentation/utils/dateHelpers";
import paths from "@/router/paths";
import ListControllerMixin from "@/utils/ListControllerMixin";
import Vue from "vue";

export default Vue.extend({
  mixins: [ListControllerMixin],
  mounted() {
    this.loadingItems = true;
    this.getData();
  },
  data() {
    return {
      $paths: paths,
      DOCTYPE_NAMES,
      hadProblemOptions: [
        { id: "", title: "Todos" },
        { id: "true", title: "Sim" },
        { id: "false", title: "Não" },
      ],
      documentTypeOptions: [
        { id: "", title: "Todos" },
        { id: 'recipe', title: DOCTYPE_NAMES[EDocumentType.PRESCRIPTION] },
        { id: 'medical_record', title: DOCTYPE_NAMES[EDocumentType.MEDICAL_RECORD] },
      ],
      filters: {
        page: 1,
        q: "",
        had_problem: "",
        action: "",
      },
      columns: [
        {
          name: "Médico",
          sortName: null,
          order: null,
        },
        {
          name: "Documento",
          sortName: null,
          order: null,
        },
        {
          name: "Problemas",
          sortName: null,
          order: null,
        },
        {
          name: "Sugestão",
          sortName: null,
          order: null,
        },
        {
          name: "Data",
          sortName: null,
          order: null,
        },
      ],
    };
  },
  computed: {
    filterStatus() {
      const f: any = {
        page: this.filters.page || 1,
        q: this.filters.q || "",
        orderBy: this.columns.filter(
          (r: any) => r.order != null && r.sortName != null,
        ),
      };
      if (this.filters.had_problem !== "") {
        f.had_problem = this.filters.had_problem === "true";
      }
      if (this.filters.action !== "") {
        f.action = this.filters.action;
      }
      return f;
    },
  },
  methods: {
    formatDate,
    fetchPromise() {
      return useCases.listPrescriptionFeedbacks.execute(this.filterStatus);
    },
    selectChanged() {
      this.loadingItems = true;
      this.getData();
    },
  },
});
